import { useIsStaffUser } from './useIsStaffUser';

// Mirrors CanCommitDraftPlots on the backend — staff-only until explicitly widened.
export const useCanCommitDraftPlots = (): boolean => useIsStaffUser();
